import { render, staticRenderFns } from "./tableContent.vue?vue&type=template&id=985b173a&scoped=true&"
import script from "./tableContent.vue?vue&type=script&lang=js&"
export * from "./tableContent.vue?vue&type=script&lang=js&"
import style0 from "./tableContent.vue?vue&type=style&index=0&id=985b173a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985b173a",
  null
  
)

export default component.exports